module.exports = __webpack_public_path__ + "img/icon_features_pause3_hover.b781fa34.svg";